window.addEventListener('keydown', function(e) {
  console.log('FIRST keydown:', e.key);
}, true);

console.log('cro-lightbox-swipe.js loaded');
console.log('readyState:', document.readyState); // ← これを追加
// modalのremoveAttributeを上書きして、矢印キー中はopenが消えるのをブロック
(function() {
  let arrowKeyDown = false;

  window.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      arrowKeyDown = true;
    }
  }, true);

  window.addEventListener('keyup', e => {
    arrowKeyDown = false;
  }, true);

  // product-modalが存在したらremoveAttributeを上書き
function patchModal() {
  const modal = document.querySelector('product-modal');
  if (!modal) { setTimeout(patchModal, 100); return; }

  let arrowKeyDown = false;

  window.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      arrowKeyDown = true;
      console.log('arrowKeyDown: true');
    }
  }, true);

  window.addEventListener('keyup', e => {
    arrowKeyDown = false;
  }, true);

  new MutationObserver(() => {
    if (arrowKeyDown && !modal.hasAttribute('open')) {
      console.log('open removed during arrow key - restoring');
      modal.setAttribute('open', '');
    }
  }).observe(modal, { attributes: true, attributeFilter: ['open'] });

  console.log('modal patched');
}

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', patchModal)
    : patchModal();
})();


(function () {
  'use strict';

  const SWIPE_THRESHOLD = 50;
  let touchStartX = 0;
  let touchStartY = 0;
  let mouseStartX = 0;
  let isDragging = false;
  let initialized = false;

  function getModal() {
    return document.querySelector('product-modal');
  }

  function isModalOpen(modal) {
    return modal.hasAttribute('open');
  }

  function getImages(modal) {
    return [...modal.querySelectorAll('img[data-media-id]')];
  }

  function getCurrentIndex(images) {
    const idx = images.findIndex(img => img.classList.contains('active'));
    return idx >= 0 ? idx : 0;
  }

  function goToIndex(images, idx) {
    images.forEach((img, i) => {
      img.classList.toggle('active', i === idx);
    });
		// スクロール位置をリセット
		const content = document.querySelector('.product-media-modal__content');
		if (content) content.scrollTop = 0;
    updateUI(idx, images.length);
  }

  function navigate(direction) {
    const modal = getModal();
    if (!modal || !isModalOpen(modal)) return;
    const images = getImages(modal);
    if (images.length <= 1) return;
    const next = (getCurrentIndex(images) + direction + images.length) % images.length;
    goToIndex(images, next);
  }

  function updateUI(idx, total) {
    const counter = document.querySelector('.clsn-counter');
    const prev    = document.querySelector('.clsn-nav--prev');
    const next    = document.querySelector('.clsn-nav--next');
    if (counter) {
      counter.textContent = `${idx + 1} / ${total}`;
      counter.hidden = total <= 1;
    }
    if (prev) prev.hidden = total <= 1;
    if (next) next.hidden = total <= 1;
  }

  function onTouchStart(e) {
    touchStartX = e.changedTouches[0].clientX;
    touchStartY = e.changedTouches[0].clientY;
  }

  function onTouchEnd(e) {
    const dx = e.changedTouches[0].clientX - touchStartX;
    const dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
      navigate(dx < 0 ? 1 : -1);
    }
  }

  function buildButton(dir, icon, label) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = `clsn-nav clsn-nav--${dir}`;
    btn.setAttribute('aria-label', label);
    btn.innerHTML = icon;
    return btn;
  }

  function initUI() {
    console.log('initUI called, initialized:', initialized);
    const modal = getModal();
    if (!modal) return;

    if (!initialized) {
      const dialog = modal.querySelector('.product-media-modal__dialog');
      if (!dialog) return;
			dialog.addEventListener('pointerup', e => e.stopPropagation());

      const prevBtn = buildButton('prev', '&#8249;', '前の画像');
      const nextBtn = buildButton('next', '&#8250;', '次の画像');
      const counter = document.createElement('div');
      counter.className = 'clsn-counter';
      counter.setAttribute('aria-live', 'polite');
      counter.setAttribute('aria-atomic', 'true');
      dialog.append(prevBtn, nextBtn, counter);

			prevBtn.addEventListener('pointerup', e => { 
				e.stopPropagation(); 
				e.stopImmediatePropagation();
				navigate(-1); 
			}, true);

			nextBtn.addEventListener('pointerup', e => { 
				e.stopPropagation(); 
				e.stopImmediatePropagation();
				navigate(1); 
			}, true);

      const touchTarget =
        modal.querySelector('.product-media-modal__content') || dialog;
      touchTarget.addEventListener('touchstart', onTouchStart, { passive: true });
      touchTarget.addEventListener('touchend',   onTouchEnd,   { passive: true });

touchTarget.addEventListener('pointerdown', e => {
  if (e.pointerType !== 'mouse') return;
  mouseStartX = e.clientX;
  isDragging = true;
  touchTarget.setPointerCapture(e.pointerId); // ドラッグ中は要素外に出ても追跡
});
touchTarget.addEventListener('pointerup', e => {
  if (e.pointerType !== 'mouse') return;
  e.stopPropagation(); // ModalDialogのpointerupで閉じるのを防ぐ
  if (!isDragging) return;
  isDragging = false;
  const dx = e.clientX - mouseStartX;
  if (Math.abs(dx) > SWIPE_THRESHOLD) {
    navigate(dx < 0 ? 1 : -1);
  }
});
touchTarget.addEventListener('pointercancel', () => { isDragging = false; });



			
      initialized = true;
    }

    const images = getImages(modal);
    updateUI(getCurrentIndex(images), images.length);
		
// モーダルを開いたときのスクロールリセット
const content = modal.querySelector('.product-media-modal__content');
if (content) {
  content.scrollTop = 0;
  content.scrollLeft = 0;
}

  }


// キーボードリスナーをページ読み込み時に即登録
  window.addEventListener('keydown', e => {
    const modal = getModal();
    console.log('keydown fired, key:', e.key, 'modalOpen:', modal ? isModalOpen(modal) : 'no modal');
    if (!modal || !isModalOpen(modal)) return;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault();
      e.stopImmediatePropagation();
      console.log('navigating...');
      navigate(e.key === 'ArrowLeft' ? -1 : 1);
    }
  }, true);

  console.log('about to call watch, readyState:', document.readyState);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', watch)
    : watch();

  function watch() {
    console.log('watch called');
    const modal = getModal();
    console.log('modal found:', modal);
    if (!modal) {
      setTimeout(watch, 300);
      return;
    }

new MutationObserver(() => {
  if (isModalOpen(modal)) {
    document.documentElement.style.overflow = 'hidden';
    initUI();
  } else {
    document.documentElement.style.overflow = '';
  }
}).observe(modal, { attributes: true, attributeFilter: ['open'] });

  }

  console.log('about to call watch, readyState:', document.readyState);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', watch)
    : watch();

})();